import Wine from "./Wine";

export default function Home () {
    return (
        <main>
            <h1>Home</h1>
            {/* <Wine /> */}
        </main>
    )
    
}